import React, { FunctionComponent, InputHTMLAttributes } from "react";
import styled from "styled-components";

import { CXXL, CL, CS } from "@/components/Typography";

interface RxPaymentPlanProps extends InputHTMLAttributes<HTMLInputElement> {
  id: string;
  monthlyPrice: string;
  paymentInterval: string;
  subTitle: string;
  previousPrice?: string;
  price?: string;
  priceText?: string;
}

const RxPaymentPlan: FunctionComponent<RxPaymentPlanProps> = (props) => {
  return (
    <S.Container data-cy={`payment-plan-${props.id}`}>
      <S.PriceBlock {...props}>
        <S.Label {...props}>{props.title}</S.Label>
        {props.previousPrice && (
          <S.PreviousPrice weight="100" roxborough>
            <s>{props.previousPrice}</s>
          </S.PreviousPrice>
        )}
        <S.Price weight="100" roxborough>
          {props.priceText ? props.priceText : `£${props.price}`}
        </S.Price>
        <CL weight="500">{props.subTitle}</CL>
        <S.SubText>
          £{props.monthlyPrice}, {props.paymentInterval}.
        </S.SubText>
      </S.PriceBlock>
    </S.Container>
  );
};

interface StyleProps {
  colour?: string;
  titleColour?: string;
}

const S = () => {};

S.Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 30px;
  width: 100%;
  max-width: 400px;
`;

S.PriceBlock = styled.div<StyleProps>`
  position: relative;
  width: 100%;
  height: 220px;
  background: white;
  border: 4px solid ${(p) => p.colour};
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 10px;
  cursor: pointer;
`;

S.Input = styled.input`
  -webkit-appearance: none;
  position: absolute;
  height: 100%;
  width: 100%;
  cursor: pointer;

  &:checked {
    outline: 5px solid black;
    border-radius: 10px;
  }
`;

S.Label = styled.div<StyleProps>`
  position: absolute;
  background: ${(p) => p.colour};
  color: ${(p) => p.titleColour};
  font-weight: 700;
  padding: 10px 20px;
  top: -20px;
`;

S.PreviousPrice = styled(CL)`
  position: absolute;
  top: 40px;
  font-size: 1.5rem;
`;

S.Price = styled(CXXL)`
  font-size: 3.8rem;
`;

S.SubText = styled(CS)`
  position: absolute;
  bottom: 20px;
`;

export default RxPaymentPlan;
